import { formatAgo } from './syncTime';
import '../../styles/components/SyncControls.scss';

const PROVIDERS = ['cdo', 'promoopcion', 'marpico', 'shopify', 'catalogos'];

const LAST_STATUS = {
  finished: '✓',
  failed: '✕ falló',
  interrupted: '⚠ interrumpida',
  running: '↻ en curso',
};

const lastSyncLabel = (last) => {
  if (!last) return 'Sin sincronizaciones';
  const when = formatAgo(last.finishedAt || last.heartbeatAt || last.createdAt);
  const errors = last.counts?.errors ? ` · ${last.counts.errors} errores` : '';
  return `${LAST_STATUS[last.status] || last.status} ${when}${errors}`;
};

const SyncControls = ({ onSync, syncingProvider, lastByProvider = {} }) => (
  <div className="sync-controls">
    <h2>Selecciona la bodega a sincronizar</h2>

    <div className="sync-controls__buttons">
      {PROVIDERS.map(provider => {
        const isThisOne = syncingProvider === provider;
        const anyRunning = !!syncingProvider;
        const last = lastByProvider[provider];
        return (
          <div key={provider} className="sync-controls__item">
            <button
              onClick={() => onSync(provider)}
              disabled={anyRunning}
              className={`btn${isThisOne ? ' btn--syncing' : ''}`}
            >
              {isThisOne ? '↻ Sincronizando...' : `Sync ${provider.toUpperCase()}`}
            </button>
            <span className={`sync-controls__last sync-controls__last--${last?.status || 'none'}`}>
              {lastSyncLabel(last)}
            </span>
          </div>
        );
      })}
    </div>
  </div>
);

export default SyncControls;
